import { createFileRoute, redirect } from '@tanstack/react-router'

import type { SiteId } from '@beaded/models'

import { siteQueries } from 'lib/queries'

import TrumpetChart from 'pages/TrumpetChart'

export const Route = createFileRoute('/_auth/sites/$id/trumpet')({
  component: TrumpetChart,
  // Only sensor sites have a trumpet chart; a sea-ice (non-sensor) site goes
  // back to its own page. Fails open: a failed lookup renders the chart page.
  beforeLoad: async ({ context: { queryClient }, params: { id } }) => {
    let pageType: string | undefined
    try {
      const data = await queryClient.ensureQueryData(
        siteQueries.detail(Number(id) as SiteId),
      )
      pageType = (data as { site?: { pageType?: string } })?.site?.pageType
    } catch {
      return
    }
    if ((pageType ?? 'sensor') !== 'sensor') {
      throw redirect({ to: '/sites/$id', params: { id }, replace: true })
    }
  },
})
